(function () {
  const gate = document.querySelector('[data-peptiva-gate]');
  if (!gate) return;
  const storageKey = 'peptiva-visit-click-v31';
  let isEnglish = gate.dataset.locale === 'en';
  const form = gate.querySelector('form');
  const panel = gate.querySelector('.peptiva-gate__panel');
  const intro = gate.querySelector('[data-peptiva-gate-intro]');
  const checks = Array.from(gate.querySelectorAll('[data-peptiva-gate-check]'));
  const continueButton = gate.querySelector('[data-peptiva-gate-continue]');
  const puzzleStep = gate.querySelector('[data-peptiva-puzzle-step]');
  const captchaContainer = gate.querySelector('[data-peptiva-captcha-widget]');
  const captchaStatus = gate.querySelector('[data-peptiva-captcha-status]');
  const captchaRetry = gate.querySelector('[data-peptiva-captcha-retry]');
  let widgetId = null;
  let verifying = false;
  const captchaKey = '6LeBBgMuAAAAAJRDf2mjhySXK-fKYZ4RPgjd7sgW';
  const verificationUrl = 'https://peptiva-captcha-verify.bdy6jg224m.chatgpt.site/verify';
  function captchaError() {
    puzzleSolved = false;
    captchaStatus.textContent = isEnglish ? 'Verification failed. Please try again.' : 'Provjera nije uspjela. Pokušajte ponovno.';
    captchaRetry.hidden = false;
    updateContinue();
  }
  function showCaptchaAgain() {
    if (gate.hidden) return;
    puzzleSolved = false;
    intro.hidden = true;
    puzzleStep.hidden = false;
    panel.setAttribute('aria-labelledby', 'PeptivaPuzzleTitle');
    updateContinue();
  }
  async function verifyCaptcha(token) {
    if (verifying) return;
    verifying = true;
    captchaStatus.textContent = isEnglish ? 'Verifying…' : 'Provjera…';
    captchaRetry.hidden = true;
    const controller = new AbortController();
    const timer = setTimeout(function () { controller.abort(); }, 10000);
    try {
      const response = await fetch(verificationUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token }), signal: controller.signal,
        credentials: 'omit', cache: 'no-store'
      });
      const result = await response.json();
      if (!response.ok || result.verified !== true) throw new Error('CAPTCHA rejected');
      captchaStatus.textContent = '';
      finishPuzzle();
    } catch (_) {
      captchaError();
      if (widgetId !== null && window.grecaptcha) window.grecaptcha.reset(widgetId);
    } finally { clearTimeout(timer); verifying = false; }
  }

  function fitCaptchaChallenge() {
    if (gate.hidden) return;
    const viewport = window.visualViewport;
    const width = viewport ? viewport.width : window.innerWidth;
    const height = viewport ? viewport.height : window.innerHeight;
    const offsetX = viewport ? viewport.offsetLeft : 0;
    const offsetY = viewport ? viewport.offsetTop : 0;
    document.querySelectorAll('iframe[src*="/recaptcha/"][src*="/bframe"]').forEach(function (frame) {
      // The Google challenge iframe has the real puzzle dimensions; its wrapper
      // may report a smaller size, leaving the Verify button below the viewport.
      const box = frame.parentElement;
      if (!box) return;
      const rect = frame.getBoundingClientRect();
      const naturalWidth = frame.offsetWidth || parseFloat(frame.getAttribute('width')) || rect.width;
      const naturalHeight = frame.offsetHeight || parseFloat(frame.getAttribute('height')) || rect.height;
      if (!naturalWidth || !naturalHeight) return;
      const scale = Math.min(1, (width - 32) / naturalWidth, (height - 32) / naturalHeight);
      if (!Number.isFinite(scale) || scale <= 0) return;
      const styles = {
        position: 'fixed',
        left: (offsetX + Math.max(8, (width - naturalWidth * scale) / 2)) + 'px',
        top: (offsetY + Math.max(8, (height - naturalHeight * scale) / 2)) + 'px',
        right: 'auto', bottom: 'auto',
        width: naturalWidth + 'px', height: naturalHeight + 'px',
        transform: 'scale(' + scale + ')',
        'transform-origin': 'top left',
        'max-width': 'none', 'max-height': 'none',
        overflow: 'visible', 'z-index': '2147483647'
      };
      Object.keys(styles).forEach(function (property) {
        const value = styles[property];
        if (box.style.getPropertyValue(property) !== value || box.style.getPropertyPriority(property) !== 'important') {
          box.style.setProperty(property, value, 'important');
        }
      });
    });
  }
  let captchaLayoutPending = false;
  function scheduleCaptchaLayout() {
    if (captchaLayoutPending || gate.hidden) return;
    captchaLayoutPending = true;
    requestAnimationFrame(function () {
      captchaLayoutPending = false;
      fitCaptchaChallenge();
    });
  }
  const captchaLayoutObserver = new MutationObserver(scheduleCaptchaLayout);
  function startCaptchaLayoutObserver() {
    captchaLayoutObserver.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('resize', scheduleCaptchaLayout);
  window.addEventListener('orientationchange', scheduleCaptchaLayout);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleCaptchaLayout);
    window.visualViewport.addEventListener('scroll', scheduleCaptchaLayout);
  }

  function loadCaptcha() {
    if (widgetId !== null) return;
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=' + (isEnglish ? 'en' : 'hr');
    script.async = true;
    script.onload = function () {
      window.grecaptcha.ready(function () {
        widgetId = window.grecaptcha.render(captchaContainer, {
          sitekey: captchaKey,
          theme: 'light',
          size: captchaContainer.clientWidth < 304 ? 'compact' : 'normal',
          callback: verifyCaptcha,
          'expired-callback': function () { showCaptchaAgain(); captchaError(); },
          'error-callback': function () { showCaptchaAgain(); captchaError(); }
        });
      });
    };
    script.onerror = captchaError;
    document.head.appendChild(script);
  }
  const country = gate.querySelector('[data-peptiva-country]');
  const language = gate.querySelector('[data-peptiva-language]');
  let puzzleSolved = false;
  const acceptanceLifetime = 30 * 24 * 60 * 60 * 1000;
  const persistentKey = 'peptiva-visit-verified-until-v1';
  function accepted() {
    try {
      const expiresAt = Number(localStorage.getItem(persistentKey));
      if (Number.isFinite(expiresAt) && expiresAt > Date.now()) return true;
      if (expiresAt) localStorage.removeItem(persistentKey);
    } catch (_) {}
    try { return sessionStorage.getItem(storageKey) === 'accepted'; }
    catch (_) { return false; }
  }
  function rememberAcceptance() {
    try { localStorage.setItem(persistentKey, String(Date.now() + acceptanceLifetime)); } catch (_) {}
    try { sessionStorage.setItem(storageKey, 'accepted'); } catch (_) {}
  }
  const visitorLocaleFallback = {
    country: country ? country.value : 'US',
    language: gate.dataset.locale === 'hr' ? 'hr' : 'en'
  };
  const visitorLocaleReady = window.peptivaVisitorLocaleReady || Promise.resolve(visitorLocaleFallback);
  visitorLocaleReady.then(function (visitor) {
    applyLanguage(visitor.language !== 'hr');
    if (country && country.querySelector('option[value="' + visitor.country + '"]')) country.value = visitor.country;
  });
  function applyLanguage(english) {
    isEnglish = english;
    gate.dataset.locale = english ? 'en' : 'hr';
    const copy = english ? {
      puzzleTitle: 'Complete the Peptiva mark', puzzleIntro: 'Slide the missing piece into the open space.', imageAlt: 'Peptiva mark with a missing piece', sliderLabel: 'Slide the piece', sliderAria: 'Slide the puzzle piece into place', check: 'Check', reset: 'New puzzle', puzzleStatus: 'Move the slider until the piece fits.',
      gateTitle: 'Welcome to Peptiva', gateIntro: 'Choose your delivery country and language, then confirm your age and research-only understanding to continue.', countryLabel: 'EU delivery country', languageLabel: 'Language' ,
      age: 'I confirm that I am at least 18 years old.', ruo: 'I understand that the listed materials are intended exclusively for lawful in vitro laboratory research and are not for use in humans or animals.', continue: 'Continue to Peptiva'
    } : {
      puzzleTitle: 'Dovrši Peptiva simbol', puzzleIntro: 'Povuci klizač da uklopiš dio u prazno mjesto.', imageAlt: 'Peptiva simbol s praznim mjestom', sliderLabel: 'Povuci dio', sliderAria: 'Povuci dio puzle na mjesto', check: 'Provjeri', reset: 'Nova puzla', puzzleStatus: 'Pomakni klizač dok se dio ne uklopi.',
      gateTitle: 'Dobro došli u Peptivu', gateIntro: 'Odaberite državu dostave i jezik te potvrdite dob i razumijevanje istraživačke namjene za nastavak.', countryLabel: 'Država dostave (EU)', languageLabel: 'Jezik' ,
      age: 'Potvrđujem da imam najmanje 18 godina.', ruo: 'Razumijem da su navedeni materijali namijenjeni isključivo zakonitom in vitro laboratorijskom istraživanju i nisu za primjenu na ljudima ili životinjama.', continue: 'Nastavi u Peptivu'
    };
    gate.querySelector('#PeptivaPuzzleTitle').textContent = english ? 'Confirm to continue' : 'Potvrdite za nastavak';
    gate.querySelector('[data-peptiva-human-intro]').textContent = english ? 'Tick the box to enter Peptiva.' : 'Kliknite kućicu za ulazak u Peptivu.';
    gate.querySelector('#PeptivaGateTitle').textContent = copy.gateTitle;
    gate.querySelector('#PeptivaGateTitle + p').textContent = copy.gateIntro;
    const fields = gate.querySelectorAll('.peptiva-gate__fields label span');
    fields[0].textContent = copy.countryLabel; fields[1].textContent = copy.languageLabel;
    const checksText = gate.querySelectorAll('.peptiva-gate__check span');
    checksText[0].textContent = copy.age; checksText[1].textContent = copy.ruo;
    continueButton.textContent = copy.continue;
    if (language) language.value = english ? 'en' : 'hr';
  }
function updateContinue() {
    continueButton.disabled = !puzzleSolved || !checks.every(function (box) { return box.checked; });
  }
  function setupPuzzle() {
    if (widgetId !== null && window.grecaptcha) window.grecaptcha.reset(widgetId);
    puzzleSolved = false;
  }
  function finishPuzzle() {
    puzzleSolved = true;
    captchaLayoutObserver.disconnect();
    puzzleStep.hidden = true;
    intro.hidden = false;
    panel.setAttribute('aria-labelledby', 'PeptivaGateTitle');
    updateContinue();
    gate.querySelector('#PeptivaGateTitle').focus();
  }
  if (!accepted() || window.Shopify && window.Shopify.designMode) {
    gate.hidden = false;
    startCaptchaLayoutObserver();
    intro.hidden = true;
    puzzleStep.hidden = false;
    panel.setAttribute('aria-labelledby', 'PeptivaPuzzleTitle');
    document.body.classList.add('peptiva-gate-open');
    window.requestAnimationFrame(function () {
      setupPuzzle();
      let captchaStarted = false;
      const startCaptcha = function () {
        if (captchaStarted || gate.hidden) return;
        captchaStarted = true;
        loadCaptcha();
      };
      const localeWait = setTimeout(startCaptcha, 1500);
      visitorLocaleReady.then(function () { clearTimeout(localeWait); startCaptcha(); }, startCaptcha);
      gate.querySelector('#PeptivaPuzzleTitle').focus();
    });
  }
  checks.forEach(function (box) { box.addEventListener('change', updateContinue); });
  continueButton.addEventListener('click', function () {
    if (!puzzleSolved || !checks.every(function (box) { return box.checked; })) { updateContinue(); return; }
    rememberAcceptance();
    captchaLayoutObserver.disconnect();
    gate.hidden = true;
    document.body.classList.remove('peptiva-gate-open');
    const sameCountry = country && country.value === window.Shopify?.country;
    const sameLanguage = language && language.value === document.documentElement.lang;
    if (sameCountry && sameLanguage) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });
  captchaRetry.addEventListener('click', function () {
    if (!window.grecaptcha || widgetId === null) { window.location.reload(); return; }
    window.grecaptcha.reset(widgetId);
    captchaStatus.textContent = '';
    captchaRetry.hidden = true;
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && accepted()) {
      captchaLayoutObserver.disconnect();
      gate.hidden = true;
      document.body.classList.remove('peptiva-gate-open');
    }
  });
  if (language) {
    language.addEventListener('change', function () {
      visitorLocaleReady.then(function (visitor) { applyLanguage(visitor.language !== 'hr'); });
    });
  }
  updateContinue();
  form.addEventListener('submit', function (event) {
    if (!puzzleSolved || !checks.every(function (box) { return box.checked; })) {
      event.preventDefault();
      if (!puzzleSolved) {
        intro.hidden = true;
        puzzleStep.hidden = false;
        window.requestAnimationFrame(setupPuzzle);
      }
      updateContinue();
    }
  });
})();
// Load heavier, page-specific interactive modules only shortly before the
// visitor reaches them. The content remains server-rendered and indexable.
(function () {
  const modules = Array.from(document.querySelectorAll('[data-peptiva-lazy-module]'));
  if (!modules.length) return;

  const loaded = new Set();
  function loadModule(element) {
    const url = element.dataset.peptivaLazyModule;
    if (!url || loaded.has(url)) return;
    loaded.add(url);
    import(url).catch(function () { loaded.delete(url); });
  }

  if (!('IntersectionObserver' in window)) {
    modules.forEach(loadModule);
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      loadModule(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '500px 0px' });

  modules.forEach(function (element) { observer.observe(element); });
})();

// Cart upsell cards (dispenser case / ebook): delegated click handler attached once
// on real page load, so it keeps working even after the cart drawer content
// is swapped in via the Section Rendering API (where inline <script> tags
// injected via innerHTML would never execute).
//
// After a successful add we send the shopper to /cart rather than reloading
// the current page: the drawer can be open on top of any page (a product
// page, the homepage, etc.), and reload() would just refresh whatever page
// happens to be underneath — which looks like an unrelated redirect. Going
// straight to /cart is predictable and is also where you'd want to be right
// after adding something.
(function () {
  if (window.__peptivaCartUpsellInit) return;
  window.__peptivaCartUpsellInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dispenser-case-upsell-add], [data-ebook-upsell-add]');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function () {
        window.location.href = Theme.routes.cart_url;
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
        alert(Theme.translations.cart_upsell_error);
      });
  });
})();

